const $allTabButtons = [...document.querySelectorAll<HTMLAnchorElement>('[data-tab-click]')]
const $allSections = [...document.querySelectorAll<HTMLElement>('[aria-labelledby]')]
const $scrollTopButton = document.querySelector<HTMLButtonElement>('[data-scroll-top]')

const closeAllTabs = (): void => {
  for (const $singleTabButton of $allTabButtons) {
    $singleTabButton.setAttribute('aria-selected', 'false')
    $singleTabButton.setAttribute('tabindex', '-1')
  }

  for (const $singleSection of $allSections) {
    $singleSection.hidden = true
  }
}

const handleTabSwitch = (event: Event): void => {
  event.preventDefault()
  closeAllTabs()
  const $clickedTabElement = event.target as HTMLAnchorElement
  const sectionID = $clickedTabElement.id
  const $tabToShow = document.querySelector(`[aria-labelledby='${sectionID}']`) as HTMLElement
  if ($tabToShow) {
    $tabToShow.hidden = false
    $clickedTabElement.setAttribute('aria-selected', 'true')
    $clickedTabElement.setAttribute('tabindex', '')
  }
}

const scrollTop = (): void => {
  window.scrollTo(0, 0)
}

init()

function init(): void {
  for (const $singleTabButton of $allTabButtons) {
    $singleTabButton.addEventListener('click', handleTabSwitch)
  }

  if ($scrollTopButton) {
    $scrollTopButton.addEventListener('click', scrollTop)
  }
}
